var template = require('../templates/PeriodPicker.html');
var moment = require('moment');
var config = {
    DATE_TYPE_FULL_DAY: 1,
    DATE_TYPE_MORNING: 2,
    DATE_TYPE_AFTERNOON: 3
};

module.exports = Backbone.View.extend({

    events: {
        'click .js-dropdown-menu a': 'onChangeType',
        'changeDate .input-daterange input': 'onChangeDate',
        'clearDate .input-daterange input': 'onChangeDate'
    },

    initialize: function(options) {
        var self = this;
        self.options = options;
        self.config = config;
        self.render();
    },

    render: function() {
        var self = this;
        self.$el.html(template({
            allowHalfDays: self.options.allowHalfDays,
            config: self.config
        }));

        var daysOfWeekDisabled = this.options.daysOfWeekDisabled || [0, 6];
        self.$('.input-daterange').datepicker({
            weekStart: 1,
            daysOfWeekDisabled: daysOfWeekDisabled,
            autoclose: true,
            format: 'dd/mm/yyyy',
            todayHighlight: true
        });
        self.$('.js-from')
            .datepicker('setDate', self.options.dateFrom);
        self.$('.js-to')
            .datepicker('setDate', self.options.dateTo);

        self.renderTypeLabel(
            self.$('.js-from-type .js-label'),
            self.options.dateFromType
        );
        self.renderTypeLabel(
            self.$('.js-to-type .js-label'),
            self.options.dateToType
        );
        self.renderTypes();

        return self;
    },

    renderTypeLabel: function($label, type) {
        var self = this;
        if (type === self.config.DATE_TYPE_MORNING) {
            $label.text('morning only');
        } else if (type === self.config.DATE_TYPE_AFTERNOON) {
            $label.text('afternoon only');
        } else {
            $label.text('full day');
        }
    },

    onChangeType: function(e) {
        e.preventDefault();
        var self = this;
        var $link = self.$(e.currentTarget);
        var value = $link.data('value');

        self.options[$link.data('type')] = value;

        var data = {};
        data[$link.data('type')] = value;
        self.trigger('change', data);

        self.renderTypeLabel(
            $link.parents('.input-group-btn').find('.js-label'),
            value
        );
    },

    onChangeDate: function(e) {
        var self = this;
        var name = self.$(e.currentTarget).attr('name');
        var data = {};
        const m = e.date ? moment(e.date) : null;

        self.options[name] = m ?
            new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : null;
        data[name] = m ?
            new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : null;
        self.trigger('change', data);
        self.renderTypes();
    },

    renderTypes: function() {
        var self = this;
        if (!self.options.dateFrom) {
            self.$('.js-from-type [data-toggle="dropdown"]')
                .addClass('disabled');
        } else {
            self.$('.js-from-type [data-toggle="dropdown"]')
                .removeClass('disabled');
        }

        if (!self.options.dateTo) {
            self.$('.js-to-type [data-toggle="dropdown"]')
                .addClass('disabled');
            if (self.options.allowHalfDays) {
                self.$('.js-from-morning').show();
            }
        } else {
            self.$('.js-to-type [data-toggle="dropdown"]')
                .removeClass('disabled');
            if (
                moment(self.options.dateTo).isSame(self.options.dateFrom)
            ) {
                self.$('.js-from-type [data-toggle="dropdown"]')
                    .removeClass('disabled');
                self.$('.js-to-type [data-toggle="dropdown"]')
                    .addClass('disabled');
                if (self.options.allowHalfDays) {
                    self.$('.js-from-morning').show();
                    self.$('.js-to-afternoon').show();
                }
            } else if (self.options.allowHalfDays) {
                self.$('.js-from-morning').hide();
                self.$('.js-to-afternoon').hide();
                if (self.options.dateFromType === config.DATE_TYPE_MORNING) {
                    self.options.dateFromType = config.DATE_TYPE_FULL_DAY;
                    self.renderTypeLabel(
                        self.$('.js-from-type .js-label'),
                        self.options.dateFromType
                    );
                    self.trigger('change', {
                        dateFromType: self.options.dateFromType
                    });
                }
            }
        }
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/PeriodPicker.js